var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Forms',{attrs:{"error":_vm.error,"defaultValue":_vm.defaultValue,"items":_vm.items,"type":_vm.type,"loading":_vm.loading,"errors":_vm.errors,"hideGoToDetailsButton":""},on:{"submit":_vm.submit}})}
var staticRenderFns = []

export { render, staticRenderFns }